import { Button, DataHeader, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTimecardProcessing extends Layout {
    buttonAssignHours: Button;
    buttonImport: Button;
    dataheaderTimecardProcessing: DataHeader;
    panelTaskFilters: Panel;
    sourceDrsTimecard: DataSource;
    sourceTimecard: DataSource;
    tableTimecards: Table;
    tableTotals: Table;
}
